// 利用 history.pushState 更新 url search，并不刷新页面。删除 search: updateURLSearch({key: undefined})
function updateURLSearch(query: Record<string, string | boolean | number | undefined>): void {
  const newUrl = new URL(location.href);
  const searchParams = new URLSearchParams(newUrl.search);

  Object.entries(query).forEach(([k, v]) => {
    if (v === undefined) {
      searchParams.delete(k);
    } else {
      searchParams.set(k, String(v));
    }
  });

  newUrl.search = '?' + searchParams.toString();
  history.pushState(undefined, '', newUrl.toString());
}

export default updateURLSearch;
